import { gql } from '@apollo/client';

export const ONLY_FILTERED_INTERVENTIONS = gql`
  query OnlyFilteredInterventions {
    interventions: getInterventions {
      id
      name
    }
  }
`;
